import React from "react";
import styled from "styled-components";

interface CategoryTabsProps {
  categories: string[];
  selectedCategory: string;
  onChange: (category: string) => void;
}

export const CategoryTabs: React.FC<CategoryTabsProps> = ({
  categories,
  selectedCategory,
  onChange,
}) => {
  return (
    <TabsContainer>
      <TabsList>
        {categories.map((category) => (
          <TabButton
            key={category}
            onClick={() => onChange(category)}
            isActive={selectedCategory === category}
            aria-selected={selectedCategory === category}
            role="tab"
          >
            {category}
          </TabButton>
        ))}
      </TabsList>
    </TabsContainer>
  );
};

const TabsContainer = styled.div`
  margin-bottom: 24px;
`;

const TabsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media screen and (max-width: 500px) {
    gap: 6px;
  }
`;

const TabButton = styled.button<{ isActive: boolean }>`
  padding: 8px 16px;
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  background-color: ${(props) => (props.isActive ? "#253ec6" : "#fff")};
  color: ${(props) => (props.isActive ? "#fff" : "#373744")};
  font-size: 14px;
  font-weight: ${(props) => (props.isActive ? 600 : 500)};
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 40px;
  display: flex;
  align-items: center;
  box-shadow: ${(props) =>
    props.isActive ? "0 2px 8px rgba(37, 62, 198, 0.2)" : "none"};

  &:hover {
    background-color: ${(props) => (props.isActive ? "#253ec6" : "#f5f5f5")};
    border-color: ${(props) => (props.isActive ? "#253ec6" : "#d3d3d3")};
  }

  &:focus-visible {
    outline: 2px solid #253ec6;
    outline-offset: 2px;
  }

  &:active {
    transform: scale(0.98);
  }

  @media screen and (max-width: 500px) {
    padding: 6px 12px;
    font-size: 13px;
    min-height: 36px;
  }
`;
